import { BRAND } from "constants/brand";
import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useGetVendorsDropdown, useCopyDeliveryCost } from "hooks/useVendors";
import Select from "components/Ui/SelectField/SelectField";

const CopyCosts = (props) => {
    const form = useRef();
    const nodeRef = useRef();

    const adminInfo = useSelector((state) => state.auth.userData);
    const [searchParams] = useSearchParams();
    const selectedCity = searchParams.get("city");
    const resolvedCityId = adminInfo?.super_admin ? selectedCity || undefined : adminInfo?.cityId;

    const getVendorsQuery = useGetVendorsDropdown({ cityId: resolvedCityId });
    const copyDeliveryCostMutation = useCopyDeliveryCost();
    const [vendor, setVendor] = useState();

    const submitHandler = async (e) => {
        e.preventDefault();

        if (!vendor) {
            props.showMessage("error", "هناك خطأ", "قم بإختيار المطعم اولا");
            return;
        }
        const vendorsId = getVendorsQuery.vendors
            .filter((v) => props.selectedVendors.includes(v.vendorId))
            .map((v) => v.id);

        try {
            await copyDeliveryCostMutation.mutateAsync({
                vendorId: vendor,
                vendorIds: vendorsId,
            });
            // Assuming `response` contains information to check if the operation succeeded

            props.showMessage("success", "تم النسخ", "تم نسخ تكاليف التوصيل للمطاعم المحددة");
            props.close(); // Uncomment if you need to close a modal or similar
        } catch (err) {
            console.error("Error adding vendor:", err);
            props.showMessage("error", "هناك خطأ", err || "حدث خطأ غير متوقع");
        }
    };

    const vendorOptions = getVendorsQuery.vendors?.map((v) => ({
        value: v.id,
        label: v.name,
    }));

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div
                        className="addItem"
                        style={{ overflow: "visible" }}
                        ref={nodeRef}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {getVendorsQuery.loading || copyDeliveryCostMutation.isPending ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div
                            className="head center"
                            style={{
                                borderTopLeftRadius: "10px",
                                borderTopRightRadius: "10px",
                            }}
                        >
                            <h5>نسخ تكاليف التوصيل إلى المطاعم المحددة</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group
                                className="mb-3"
                                // style={{ height: 400 }}
                                controlId="vendor"
                            >
                                <Form.Label>
                                    المطعم<span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Select
                                    options={vendorOptions}
                                    placeholder="اختر المطعم"
                                    isSearchable
                                    onChange={(selected) => {
                                        if (!selected || selected.value === "") {
                                            setVendor(null);
                                        } else {
                                            setVendor(selected.value);
                                        }
                                    }}
                                />
                            </Form.Group>

                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    نسخ المناطق
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default CopyCosts;
